import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useInView } from '../../hooks/useInView';
import { Plus, Minus } from 'lucide-react';

const faqs = [
{ q: 'How long before I see results?', a: 'Most men begin to notice improvements within 2–4 weeks of consistent daily use. Optimal results are typically experienced after 4–8 weeks. Individual results may vary depending on physiology, diet, and lifestyle.' },
{ q: 'How many capsules do I take daily?', a: 'Take 2 capsules daily, ideally with your morning meal and a full glass of water. Do not exceed the recommended daily dose.' },
{ q: 'Who is RELOAD for?', a: 'RELOAD is designed for adult men — typically aged 25 and above — who want to support their sexual performance, reproductive health, libido, and overall vitality using natural, plant-based ingredients.' },
{ q: 'Are all the ingredients natural?', a: 'Yes. Every ingredient in RELOAD is plant-based or a naturally occurring essential mineral. The formula contains Pygeum Africanum, Catuaba Bark, Korean Ginseng, Zinc, and Selenium — with no synthetic hormones or artificial additives.' },
{ q: 'Is it safe to take RELOAD daily?', a: 'RELOAD is formulated with natural ingredients and is intended for daily use. If you are taking prescription medications or have an existing health condition, we recommend consulting your GP before starting any new supplement.' },
{ q: 'What is your returns policy?', a: 'We offer a 30-day satisfaction guarantee. If you are not completely satisfied with RELOAD, please contact us within 30 days of receipt for a full refund. See our Shipping & Returns page for full details.' },
{ q: 'How does Subscribe & Save work?', a: 'Subscribe & Save gives you RELOAD delivered automatically every 30 days at £21.99 per month — saving you versus one-time purchase. You\'ll receive priority fulfilment and UK delivery is always included. Simply select Subscribe & Save on the shop page to get started.' },
{ q: 'Can I cancel my subscription anytime?', a: 'Yes, absolutely. There is no contract or minimum term. You can cancel, pause, or adjust your subscription at any time directly from your account — with no questions asked and no cancellation fees.' }];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};


export default function FAQSection() {
  const [open, setOpen] = useState(null);
  const [ref, inView] = useInView(0.1);

  return (
    <section id="faq" data-testid="faq-section" style={{ backgroundColor: '#F7F7F5', padding: '96px 0' }}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <div ref={ref} className="max-w-3xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-14 fade-up ${inView ? 'visible' : ''}`}>
          <span className="overline block mb-4">Got Questions?</span>
          <h2 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', color: '#0D1A2E', letterSpacing: '-0.025em' }}>
            Frequently Asked Questions
          </h2>
        </div>

        <div className={`fade-up delay-1 ${inView ? 'visible' : ''}`} style={{ backgroundColor: '#FFFFFF', borderRadius: '16px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
          {faqs.map((faq, i) =>
          <div key={faq.q} data-testid={`faq-item-${i}`} className="faq-item">
              <button
              onClick={() => setOpen(open === i ? null : i)}
              data-testid={`faq-toggle-${i}`}
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', gap: '16px' }}>

                <span style={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.98rem', fontWeight: 600, color: open === i ? '#1B3D7E' : '#0D1A2E', lineHeight: 1.4, transition: 'color 0.2s' }}>
                  {faq.q}
                </span>
                <div style={{ width: '28px', height: '28px', borderRadius: '50%', border: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, backgroundColor: open === i ? 'rgba(27,61,126,0.08)' : '#F7F7F5', transition: 'all 0.2s' }}>
                  {open === i ? <Minus size={13} style={{ color: '#1B3D7E' }} /> : <Plus size={13} style={{ color: '#64748B' }} />}
                </div>
              </button>
              {open === i &&
            <div data-testid={`faq-answer-${i}`} style={{ padding: '0 24px 22px' }}>
                  <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.88rem', color: '#64748B', lineHeight: 1.85 }} className="!text-[#64748B]">
                    {faq.a}
                  </p>
                </div>
            }
            </div>
          )}
        </div>
      </div>
    </section>);

}